import { Box, IconButton, Stack, Typography } from '@mui/material'
import { MoreVertical20Regular } from '@/components/Icon'
import ConnectionUsageSparkline from '@/components/Settings/ConnectionUsageSparkline'
import shared from '@/components/Settings/settingsShared.module.scss'

export default function ConnectionsDirectoryRow({ row, isLast, menuAnchor, menuRowId, onOpenRowMenu }) {
  return (
    <Box
      component="li"
      aria-label={`${row.title}${row.email ? `, ${row.email}` : ''}`}
      className={isLast ? shared.connectionRowLast : shared.connectionRow}
    >
      <Stack direction="row" className={shared.connectionRowInner}>
        {row.iconUrl ? (
          <Box component="img" src={row.iconUrl} alt="" width={24} height={24} className={shared.connectionIcon} />
        ) : (
          <Typography component="span" aria-hidden className={shared.connectionGlyph}>
            {row.title.slice(0, 1).toUpperCase()}
          </Typography>
        )}
        <Stack direction="column" spacing={0.25} className={shared.connectionTextCol}>
          <Typography variant="body2" component="span" className={shared.connectionTitle}>
            {row.title}
          </Typography>
          {row.email ? (
            <Typography variant="caption" color="text.secondary" className={shared.connectionEmail}>
              {row.email}
            </Typography>
          ) : null}
        </Stack>
        <ConnectionUsageSparkline connectionId={row.id} label={row.title} />
        <IconButton
          type="button"
          className={`connection-row-menu-btn ${shared.connectionMenuBtn}`}
          size="small"
          aria-label={`More actions for ${row.title}`}
          aria-haspopup="true"
          aria-expanded={Boolean(menuAnchor) && menuRowId === row.id}
          onClick={(e) => onOpenRowMenu(e, row.id)}
        >
          <MoreVertical20Regular />
        </IconButton>
      </Stack>
    </Box>
  )
}
